import { render, staticRenderFns } from "./_form.venue-events.page.vue?vue&type=template&id=78f772d7&scoped=true&"
import script from "./_form.venue-events.page.vue?vue&type=script&lang=js&"
export * from "./_form.venue-events.page.vue?vue&type=script&lang=js&"
import style0 from "./_form.venue-events.page.vue?vue&type=style&index=0&id=78f772d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f772d7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VForm,VResponsive})
